import { Drawer, IconButton } from "@mui/material";
import { FiGift, FiHome, FiStar, FiX } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";

export default function MenuSidebar({ onClose }) {
  const navigate = useNavigate();
  const { menuLink } = useParams();
  const menuItems = [
    { label: "اطلاعات رستوران", icon: FiHome, path: "info" },
    { label: "ثبت نظر", icon: FiStar, path: "ReviewForm" },
    { label: "عضویت در باشگاه مشتریان", icon: FiGift, path: "club" },
  ];

  const openPage = (path) => {
    navigate(`/menu/${menuLink}/${path}`);
    onClose();
  };

  return (
    <Drawer anchor="right" open onClose={onClose} dir="rtl" PaperProps={{ className: "w-72 max-w-[85vw]" }}>
      <div className="flex min-h-full flex-col p-5">
        <div className="flex items-center justify-between border-b border-gray-100 pb-4">
          <h2 className="text-lg font-black text-gray-900">راهنمای منو</h2>
          <IconButton onClick={onClose} aria-label="بستن راهنمای منو"><FiX /></IconButton>
        </div>
        <nav className="mt-4 flex-1" aria-label="صفحات منوی رستوران">
          <ul className="space-y-2">
            {menuItems.map(({ label, icon: Icon, path }) => (
              <li key={path}>
                <button type="button" onClick={() => openPage(path)} className="flex min-h-12 w-full items-center gap-3 rounded-xl px-4 text-right font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary/30"><Icon aria-hidden="true" /><span>{label}</span></button>
              </li>
            ))}
          </ul>
        </nav>
        <p className="border-t border-gray-100 pt-4 text-xs text-gray-400">با میزبان</p>
      </div>
    </Drawer>
  );
}
